import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';
import classNames from 'classnames';

import { ColorStyleProps } from '../../../@types/theme';
import BadgeWithIcon from '../../atoms/BadgeWithIcon';

import styles from './Legend.module.scss';

export interface Props
  extends Omit<React.HTMLAttributes<HTMLElement>, 'onClick'> {
  keys: Array<{ label: string | number; disabled: boolean }>;
  colors: ColorStyleProps[];
  onClick: (key: string | number, index: string | number) => void;
}

/**
 *
 * @note Check if we really need this component and rename it to something less generic
 * @returns
 */
const Legend: React.FunctionComponent<Props> = ({
  className,
  keys,
  colors,
  onClick,
  ...htmlElementProps
}) => (
  <div className={classNames(styles.legend, className)} {...htmlElementProps}>
    {keys.map((key, index) => (
      <BadgeWithIcon
        key={key.label}
        content={key.label as string}
        icon={faCheck}
        color={colors[index]}
        disabled={key.disabled}
        onClick={() => onClick(key.label, index)}
      />
    ))}
  </div>
);

export default Legend;
